import { QueryKey } from '@tanstack/react-query'
import AgencyService from 'services/agenciesService'

const getAgencyRexId = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<number | undefined> => {
  const token = await getAuthToken()

  const agencyId = queryKey[1] as string
  const service = new AgencyService(token)

  const result = await service.agencyService.get('GetAgencyRexId', { agencyId })

  return result.data
}

export default getAgencyRexId
